import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import toast from "react-hot-toast";
import Navbar from "../components/Navbar";
import { db } from "../firebase"; // Import your Firestore instance
import { doc, updateDoc } from "firebase/firestore"; // Import Firestore functions

function AddCaseNotes() {
  const navigate = useNavigate();
  const location = useLocation();
  const [notes, setNotes] = useState("");
  const caseData = location.state?.caseData;
  const previousPath = location.state?.from || "/";

  useEffect(() => {
    if (caseData?.caseNotes) {
      setNotes(caseData.caseNotes); // Set initial notes from caseData
    } else {
      setNotes(""); // Default to empty if no case notes
    }
  }, [caseData]);

  const handleSave = async () => {
    try {
      // Determine the collection based on case status
      const collectionName =
        caseData.status === "Disposed" ? "disposed" : "pending"; // Ensure status matches
      const caseDocRef = doc(db, collectionName, caseData.id); // Reference the correct document

      // Update the existing caseNotes field in Firestore
      await updateDoc(caseDocRef, {
        casenotes: notes, // Update the casenotes field
      });
      toast.success("Notes updated successfully");

      // Clear the notes field after saving
      setNotes("");

      // Navigate back to the previous page with updated case data
      navigate((-1));
    } catch (error) {
      toast.error("Error updating notes: " + error.message);
    }
  };



  return (
    <div className="min-h-screen bg-[#0c0a29] text-black relative">
      <Navbar />
      <div className="background-circle circle-3 z-0"></div>
      <div className="background-circle circle-4 z-0"></div>

      <main className="px-4 md:px-36 py-8">
        <div className="p-6">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center">
              <button onClick={() => navigate(-1)} className="text-white">
                <ArrowLeft />
              </button>
              <h1 className="text-2xl font-bold text-yellow-500 ml-4">Case Notes</h1>
            </div>
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-[#FFB800] text-white rounded-lg"
            >
              Save
            </button>
          </div>

          <div className="bg-white rounded-2xl p-6">
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add Your Case Notes"
              className="w-full h-96 p-4 border-none outline-none resize-none"
            />
          </div>
        </div>
      </main>
    </div>
  );
}

export default AddCaseNotes;
